import type { ReadContentCommandResult } from '@atlassian/rovo-content-bridge-api-commands';

import { log } from '../utils/aifc-logging';
import { getDocument } from '../utils/bridge-document-utils';

import { CommandHandler } from './types/command-handler-types';

export class ReadContentCommandHandler extends CommandHandler<void, ReadContentCommandResult> {
	listen(): Promise<ReadContentCommandResult> {
		return new Promise<ReadContentCommandResult>(async (resolve) => {
			const defaultResult = {
				contentType: 'page' as const,
				pageBody: undefined,
				contentId: this.properties.contentId,
				selectionFragment: '',
				selectionLocalIds: '',
				selectionMarkdown: '',
				isViewMode: this.properties.isViewMode,
			};

			try {
				const document = await getDocument(this.properties.editorAPI);
				if (!document) {
					// TODO: report this error
					resolve(defaultResult);
				}

				const selection = this.properties.editorAPI.aiExperience?.actions.getAISelectionContext();
				log('Read content result', { contentId: this.properties.contentId, document, selection });

				resolve({
					contentType: 'page',
					pageBody: document,
					contentId: this.properties.contentId,
					selectionFragment: selection?.selectionFragment
						? JSON.stringify(selection.selectionFragment)
						: '',
					selectionLocalIds: selection?.localIds ? JSON.stringify(selection.localIds) : '',
					selectionMarkdown: selection?.selectionMarkdown ?? '',
					isViewMode: this.properties.isViewMode,
				});
			} catch {
				// TODO AFC-194: report this error
				resolve(defaultResult);
			}
		});
	}
}
